export default defineNuxtPlugin(() => {
  if (import.meta.client) {
    const script = document.createElement('script');
    script.type = 'module';
    script.src = 'https://cdn.mu.chat/embeds/dist/chatbox/index.js?v=2';
    script.onload = async () => {
      //@ts-ignore
      const Chatbox = await import("https://cdn.mu.chat/embeds/dist/chatbox/index.js?v=2");
      await Chatbox.default.initBubble({
        agentId: 'cm4dy2vet001csqabeusc2hhn',
      });
    };
    document.body.appendChild(script);
  }
});
